var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.583 6.393 11.99 12.04 11.84-11.79-.452-.5A15.567 15.567 0 0 0 15.424 1h-.026A15.48 15.48 0 0 0 4.06 5.891l-.477.503zm11.99 10.058L5.54 6.394a14.047 14.047 0 0 1 9.883-3.988h.025A14.227 14.227 0 0 1 25.48 6.594l-9.907 9.858zM26.56 9.605 27.664 8.5l.276.452A14.515 14.515 0 0 1 15.523 31h-.025A14.523 14.523 0 0 1 3.132 8.9l.25-.425 1.33 1.33c-.263.38-.474.793-.627 1.228a5.556 5.556 0 0 0 3.361 7.124 5.634 5.634 0 0 0 4.992-.627l3.085 3.11 3.537-3.536a5.04 5.04 0 0 0 1.104.552 5.448 5.448 0 0 0 6.948-3.286 5.39 5.39 0 0 0-.552-4.766zM5.74 13.24c0-.65.212-1.284.603-1.805l4.164 4.138a2.87 2.87 0 0 1-1.806.628 2.965 2.965 0 0 1-2.96-2.96zm15.126 2.083a2.87 2.87 0 0 0 1.655.502 2.965 2.965 0 0 0 2.46-4.616l-4.114 4.113z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGno);
export default __webpack_public_path__ + "static/media/GNO.684298f1747feac1950a4b49cabd6efd.svg";
export { ForwardRef as ReactComponent };